import { render, staticRenderFns } from "./materReturn_Detail.vue?vue&type=template&id=51f0b69c&"
import script from "./materReturn_Detail.vue?vue&type=script&lang=js&"
export * from "./materReturn_Detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports